import { render, staticRenderFns } from "./EmployeeReportStep.vue?vue&type=template&id=64b4b9a8&"
import script from "./EmployeeReportStep.vue?vue&type=script&lang=js&"
export * from "./EmployeeReportStep.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeReportStep.vue?vue&type=style&index=0&id=64b4b9a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports